import React, { type FC, useCallback, useEffect } from 'react';
import { useTranslation, usePanorama } from '@wix/yoshi-flow-editor';
import { Plus } from '@wix/wix-ui-icons-common/on-stage';
import { Modal, Interaction } from '@constants';
import {
  useBiLogger,
  BiModalType,
  type BiAddButtonPlace,
} from '@services/BiLogger';
import { Button } from '@components/Button';
import { useModalContext } from '@components/Modal';
import { DataHooks } from './DataHooks';

type Props = {
  renderPlace: BiAddButtonPlace;
};

export const AddButton: FC<Props> = ({ renderPlace }) => {
  const { t } = useTranslation();
  const { openModal } = useModalContext();
  const { biLogger } = useBiLogger();
  const panoramaClient = usePanorama();

  useEffect(() => {
    biLogger?.reportAddButtonRendered({ renderPlace });
  }, [biLogger, renderPlace]);

  const handleClick = useCallback(() => {
    biLogger?.reportAddButtonClicked();

    openModal(Modal.AddPaymentMethod);

    panoramaClient.transaction(Interaction.LoadAddPaymentMethodModal).start();
    biLogger?.reportModalLoadStarted({
      modalType: BiModalType.AddPaymentMethod,
    });
  }, [biLogger, panoramaClient, openModal]);

  return (
    <Button
      wiringVariant="primary"
      prefixIcon={<Plus aria-hidden="true" />}
      data-hook={DataHooks.Root}
      onClick={handleClick}
    >
      {t('app.add-payment-method-button.text')}
    </Button>
  );
};
